import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import Button from '@stories/Components/Buttons/GeneralButton/Button';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import SectionWrapperStyles from '../SectionWrapper/SectionWrapper.styles';
const Container = styled(SectionWrapper) `
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${rgba(brand.black, 0.8)};
  width: 100%;
  height: 100%;
  display: none;
  z-index: 100;

  ${SectionWrapperStyles.Inner} {
    height: 100%;
    display: flex;
    align-items: center;
    background-color: ${rgba(brand.black, 0.8)};
  }

  &[data-visible='true'] {
    display: block;
  }
`;
const CloseBtn = styled(Button) `
  position: absolute;
  top: 32px;
  right: 32px;
`;
const VideoHolder = styled.div `
  ${baseGrid};
  height: 100%;
`;
const VideoContainer = styled.figure `
  grid-column: span 12;
  width: 100%;

  align-self: center;
  justify-self: center;
  text-align: center;

  ${({ isImage }) => isImage
    ? css `
          max-width: 1400px;
        `
    : css `
          max-width: 1200px;
        `}
`;
const VideoWrapper = styled.div `
  aspect-ratio: 16 / 9;
`;
const YouTubeLink = styled.a `
  font-family: var(--fontFamily);
  font-weight: 900;
  color: ${brand.white};
  display: inline-block;
  margin: 30px auto 0;
  font-size: ${fluidAdjusted(16, 18)};
  line-height: ${fluidAdjusted(20, 20)};
  text-decoration: none;

  svg {
    height: ${fluidAdjusted(24, 32)};
    vertical-align: middle;
    padding-left: 10px;
  }
`;
const Image = styled.img `
  width: 100%;
`;
const VideoModalStyles = {
    CloseBtn,
    Container,
    VideoContainer,
    VideoHolder,
    VideoWrapper,
    YouTubeLink,
    Image,
};
export default VideoModalStyles;
